import * as Sentry from 'mage-deps/@sentry/browser'

export default function handleEducationError(error, extras = {}) {
  console.error('Education error caught:', error)

  if (extras.componentStack) {
    console.error('Component stack:', extras.componentStack)
  }

  const isExpectedError = error.request && [0, 400, 403].includes(error.request.status)

  if (!isExpectedError) {
    const mergedExtras = {
      request: error.request,
      response: error.response,
      ...extras
    }

    let errorId

    Sentry.withScope(scope => {
      scope.setTag('team', 'met')
      scope.setExtras(mergedExtras)

      errorId = Sentry.captureException(error)
    })

    console.error('Error id:', errorId)

    return errorId
  }
}
